/**
 * ShippingListPresenter
 * --
 */
import React from 'react';
import { Content, Title, Row, Col, ModalLayout } from 'components';
import { Divider, Empty, Spin } from 'antd';
// import { LoadingOutlined } from '@ant-design/icons';
// import { ExpandableContainer, Table, Statistic } from 'components';
// import { Button, Input, Select } from 'antd';

import RentalFilter from './components/RentalFilter';
import RentalSummaryStatics from './components/RentalSummaryStatics';

import RentalData from './components/RentalData';
import ShopInformationList from '../OrderList/components/ShopInformationList';

const ShippingListPresenter = ({
  permission,
  loading,
  searchFilter,
  onSearch,
  onReload,
  onChange,
  //
  rentalList,
  currentShop,
  setCurrentShop,
  onResetFilter,
  onSaveDeliveryInfo,
  shipping_type,
  onCancel,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  // 결제완료 데이터
  // const completedData = orderList.filter(
  //   (o) => o.payment_state === 'COMPLETED'
  // );
  // // 환불/취소 데이터
  // const refundedData = orderList.filter(
  //   (o) => o.purchase_status === 'REFUNDED'
  // );
  // const refundCount = refundedData.length ?? 0;
  // const refundPrice =
  // refundedData.reduce((acc, cur) => acc + cur.payment_price ?? 0, 0) ?? 0;
  // const totalCount = orderList.length ?? 0;
  // const totalPrice =
  //   orderList.reduce((acc, cur) => acc + cur.payment_price ?? 0, 0) ?? 0;
  // const totalDiscount =
  //   completedData.reduce((acc, cur) => acc + cur.final_discount ?? 0, 0) ?? 0;
  const {
    totalCount,
    processingCount,
    refundCount,
    refundPrice,
    totalPrice,
    totalDiscount,
    orderList,
  } = React.useMemo(() => {
    // const completedData = parcelServiceList.filter(
    //   (o) => o.purchase_status !== 'REFUNDED'
    // );

    // 환불/취소 데이터
    const refundedData = rentalList.filter(
      (o) => o.purchase_status === 'REFUNDED'
    );
    const totalPrice = rentalList.reduce(
      (acc, cur) =>
        acc +
          cur?.rental_payment_info?.reduce(
            (acc, cur) => acc + cur.price ?? 0,
            0
          ) ?? 0,
      0
    );
    const totalDiscount = rentalList.reduce(
      (acc, cur) => acc + cur.discount_price,
      0
    );
    const refundPrice = refundedData.reduce(
      (acc, cur) =>
        acc + cur.refund.reduce((acc, cur) => acc + cur.refund_amount, 0) ?? 0,
      0
    );
    const processingList = rentalList.filter((o) => o.is_active === 'Y');
    return {
      totalCount: rentalList.length ?? 0,
      processingCount: processingList.length ?? 0,
      refundCount: refundedData.length ?? 0,
      totalPrice: totalPrice,
      refundPrice: refundPrice,
      totalDiscount: -Math.abs(totalDiscount),
      orderList: rentalList,
    };
  }, [rentalList]);

  /* ===== FUNCTION ===== */

  /* ===== HOOKS ===== */

  /* ===== RENDER ===== */
  // JSX: start
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title size={3} style={{ marginBottom: 12 }}>
            {/* 배송 목록 */}
            렌탈 상품 관리
          </Title>

          {/* 요약 */}
          <RentalFilter
            onChange={onChange}
            searchFilter={searchFilter}
            onSearch={onSearch}
            onResetFilter={onResetFilter}
            defaultShop={permission === 'ADMIN' ? null : currentShop}
            onSelect={setCurrentShop}
            permission={permission}
          />
          {/* 요약 */}
          <RentalSummaryStatics
            totalCount={totalCount ?? 0}
            processingCount={processingCount ?? 0}
            refundCount={refundCount ?? 0}
            //
            totalPrice={totalPrice ?? 0}
            totalDiscount={totalDiscount ?? 0}
            refundPrice={refundPrice ?? 0}
          />
          {/* 요약 */}
          <Spin spinning={loading}>
            <Row style={{ minHeight: '50vh' }}>
              {/* {permission === 'ADMIN' && (
                <Col x={3}>
                  <ShopInformationList onChange={setCurrentShop} />
                </Col>
              )} */}
              {/* === 업체목록 === */}
              {/* === Data === */}
              <Col
                // x={permission === 'ADMIN' ? 21 : 24}
                x={24}
                style={{
                  borderLeft: '1px solid #EBEBEB',
                }}
              >
                <RentalData
                  type={shipping_type}
                  orderList={orderList}
                  onSaveDeliveryInfo={onSaveDeliveryInfo}
                  onReload={onReload}
                  onCancel={onCancel}
                />
              </Col>
            </Row>
          </Spin>

          <Divider />
        </Col>
      </Row>
    </Content>
  );
};

export default ShippingListPresenter;
